import React from 'react'
import Snackbar from '../../UI/Snackbar'

type Props = {
  loadAction: string
}

const LoadActionModal = ({ loadAction }: Props) => {
  switch (loadAction) {
    case 'delete':
      return <Snackbar text="Load Deleted" />
    default:
      break
  }
}

export default LoadActionModal
